'use strict';

function InkFile(filename, fileAwsKey) {
    var self = this;
    self.name = ko.observable(filename);
    self.awsKey = fileAwsKey;
    self.validSrt = ko.observable();
}

function ExportFileType(name, description, value, checked, extension) {
    var self = this;
    self.name = name;
    self.description = description;
    self.value = value;
    self.extension = extension;
    self.checked = ko.observable(checked);
    self.formattedName = ft_String.format('{0} ({1})', self.description, self.extension);
}

var CaptionConverterModel = function CaptionConverterModel(exportableTypes) {
    var self = this;

    self.files = ko.observableArray();
    self.exportConversionTypes = [];
    self.overlayOn = ko.observable(false);
    self.email = ko.observable('');
    self.convertPossible = ko.observable(false);
    self.stepsBarVisible = ko.observable(true);
    self.errors = ko.observableArray();

    // Helper functions
    var _atLeastOneSrtUploaded = function _atLeastOneSrtUploaded() {
        return self.files().length > 0;
    };

    var _atLeastOneExportTypeChecked = function _atLeastOneExportTypeChecked() {
        return _.any(self.exportConversionTypes, function (item) {
            return item.checked();
        });
    };

    var _atLeastOneInvalidSrt = function _atLeastOneInvalidSrt() {
        return _.any(self.files(), function (item) {
            return item.validSrt() === false;
        });
    };

    _.each(exportableTypes, function (item) {
        self.exportConversionTypes.push(new ExportFileType(item.name, item.description, item.value, false, item.extension));
    });

    this.removeSrtFile = function (file) {
        self.files.remove(file);

        if (!_atLeastOneInvalidSrt()) self.errors.removeAll();
    };

    self.currentStep = ko.computed(function () {
        if (!_atLeastOneSrtUploaded()) return 1;

        if (!_atLeastOneExportTypeChecked()) return 2;

        return 3;
    });

    self.convert = function () {
        var modelIsValid = self.validate();

        if (modelIsValid) {
            self.convertPossible(true);

            var keys = _.map(self.files(), function (file) {
                return file.awsKey;
            });
            var exportTypes = _.filter(self.exportConversionTypes, function (type) {
                return type.checked();
            });

            $.post('/captionconverter/captionconversionattempt', {
                email: self.email(),
                keys: keys,
                exportTypes: _.pluck(exportTypes, 'name')
            });
        }
    };

    self.checkValidSrt = function (file) {
        $.get('/captionconverter/checkvalidsrt', {
            key: file.awsKey
        }).done(function (response) {
            if (response && !response.ok) file.name(response.error);

            file.validSrt(response.ok);
        }).fail(function (err) {
            console.debug('found error: ' + err); //eslint-disable-line
        });
    };

    self.validate = function () {
        var isModelValid = true;
        self.errors([]);

        if (!_atLeastOneSrtUploaded()) {
            isModelValid = false;
            self.errors.push('Please upload at least one .srt file');
        }

        if (!_atLeastOneExportTypeChecked()) {
            isModelValid = false;
            self.errors.push('Please choose at least one export type');
        }

        if (_atLeastOneInvalidSrt()) {
            isModelValid = false;
            self.errors.push('At least one file is not a valid .srt');
        } else {
            // Regex from: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
            var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var validEmailAddress = emailRegEx.test(self.email());
            if (!validEmailAddress) {
                isModelValid = false;
                self.errors.push('Please input a valid email address');
            }
        }

        return isModelValid;
    };
};